import Axios from 'axios';
import _isEmpty from 'lodash-es/isEmpty';
import { logout } from '@teetsh/app/src/queries/user/useLogout';

export const axios = Axios.create({
  baseURL: import.meta.env.VITE_API_URL,
});

// Shared utility functions
export const getAuthHeaders = (): HeadersInit => {
  const token = localStorage?.getItem('id_token') || '';
  const shareToken = (window as any)?.shareToken;

  if (!_isEmpty(shareToken)) {
    return { Authorization: shareToken };
  }
  if (token !== '') {
    return { Authorization: `Bearer ${token}` };
  }
  return {};
};

axios.interceptors.response.use(
  _ => _,
  error => {
    const statusCode = error && error.response ? error.response.status : '';
    if (statusCode === 503) {
      const maintenanceUrl = `${import.meta.env.VITE_APP_URL}/maintenance`;
      if (window.location.href !== maintenanceUrl) {
        window.location.href = maintenanceUrl;
      }
    }
    if (statusCode === 401) {
      const errors = error?.response?.data?.errors || [];
      // If token is expired or invalid, we logout
      if (
        errors.length > 0 &&
        (errors[0]?.title || []).startsWith('Error parsing token')
      ) {
        logout();
        const loginUrl = `${import.meta.env.VITE_APP_URL}/login`;
        if (window.location.href !== loginUrl) {
          window.location.href = loginUrl;
        }
      }
    }
    return Promise.reject(error);
  },
);
interface RequestOptions {
  method: 'GET' | 'POST' | 'PATCH' | 'DELETE' | 'PUT';
  body?: any;
  headers?: any;
  params?: any;
}

export default function request(url: string, opt: RequestOptions) {
  const authHeaders = getAuthHeaders();
  const options = {
    ...opt,
    headers: {
      ...authHeaders,
      ...opt.headers,
    },
  };

  return axios({
    url,
    withCredentials: true,
    method: options.method ? options.method : 'get',
    headers: options.headers,
    data: options.body,
    params: options.params,
  }).then(response => response.data);
}
